import sharedText from '@sicfe/shared/src/locale/nl/i18n';
import roomText from '@sicfe/rooms/src/locale/nl/i18n';
import debugText from '@sicfe/debug/src/locale/nl/i18n';
import highCharts from './high-charts';
export default {
    roomText,
    highCharts,
    debugText,
    sharedText,
    drawer: {
        rooms: 'Ruimtes',
    },
};
